import { render } from "./SupplierSelect.vue?vue&type=template&id=0538a654&scoped=true&ts=true"
import script from "./SupplierSelect.vue?vue&type=script&lang=ts"
export * from "./SupplierSelect.vue?vue&type=script&lang=ts"

import "./SupplierSelect.vue?vue&type=style&index=0&id=0538a654&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0538a654"]])

export default __exports__